/**
 * Primary JS file for nvb4.
 *
 * Localized vars available as nvb4ThemeVars.
 */

(($) => {

  const nvb4Theme = {

    /**
     * Initialize common selectors as jQ objects.
     */
    initElCache: () => {
      const nt = nvb4Theme;
      nt.window = $(window);
      nt.html = $('html');
      nt.body = $('body');
      nt.isotopeTarget = $('.non-featured-posts-area');
      nt.siteHeader = $('#masthead');
      nt.siteNavigation = $('#site-navigation');
      nt.siteNavigationInner = nt.siteNavigation.find('.main-navigation-inner');
      nt.mobileMenuToggle = $('.mobile-menu-toggle');
      nt.secondaryMenuSlot = $('.secondary-menu-slot');
      nt.secondaryMenu = $('#secondary-menu');
    },

    /**
     * Center the secondary menu when on a mobile screen.
     */
    centerSecondaryMenuForMobile: () => {
      const nt = nvb4Theme;
      const windowWidth = nt.window.width();

      if (windowWidth < 743) {
        // Get width of the items within the menu.
        let menuItemsWidth = 0;
        nt.secondaryMenu.find('li').each((i, el) => {
          menuItemsWidth += $(el).outerWidth();
        });
        // Determine how much it overflows the window and calculate how much
        // to scroll.
        const overflow = menuItemsWidth - parseInt(windowWidth, 10);
        if (overflow > 0) {
          const left = Math.floor(overflow / 2);
          nt.secondaryMenu.scrollLeft(Math.abs(left));
        }
      }
    },

    /**
     * Call this for clicks on menu links and their expander icons.
     *
     * @return void
     * @param $link
     */
    linkAndIconClickHandler: ($link) => {
      const $li = $link.closest('li');
      if ($li.hasClass('focus')) {
        $li.removeClass('focus');
        $li.find('.icon')
          .first()
          .addClass('icon-triangle-right')
          .removeClass('icon-triangle-down');
      } else {
        $li.addClass('focus');
        $li.find('.icon')
          .first()
          .addClass('icon-triangle-down')
          .removeClass('icon-triangle-right');
      }
    },

    /**
     * Inject icons in primary menu items with children.
     */
    applyPrimaryMenuIcons: () => {
      nvb4Theme.siteNavigation
        .find('.menu-item-has-children > a')
        .each((i, el) => {
          const $link = $(el);

          // Inject the icon.
          // $link.append( '<span class="icon icon-triangle-right"></span>' );
          $link.append(
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z" fill=" fill="#ffffff""></path><path d="M0 0h24v24H0z" fill="none"></path></svg>',
          );

          // Have the icon handle clicks by expanding the child menu.
          // Attach handler directly to $icon (rather than as a selector passed
          // to $link) for wider support in Android.

          const $icon = $link.find('.icon');
          $icon.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            nvb4Theme.linkAndIconClickHandler($link);
          });

          // Handle link clicks for destinationless items. (treat them like icon clicks)
          if ($link.hasClass('no-destination')) {
            $link.on('click', (e) => {
              e.preventDefault();
              nvb4Theme.linkAndIconClickHandler($link);
            });
          }
        });

    },

    /**
     * Apply FitVids to the post content.
     */
    applyFitvids: () => {
      $('.entry-content').fitVids();
    },

    applyIsotope: () => {
      const nt = nvb4Theme;

      if (nvb4Theme.body.hasClass('aggregation-view')) {
        // eslint-disable-next-line no-underscore-dangle
        nt.isotopeTarget.isotope({
          itemSelector: '.hentry:not(.top)',
          stamp: '.hentry.top, .page-header',
          layoutMode: 'masonry',
          percentPosition: true,
          masonry: {},
          transitionDuration: '0.2s',
        });
      }
    },

    /**
     * Apply sticky nav functionality to secondary menu.
     */
    applyStickinessToSecondaryMenu: () => {
      const nt = nvb4Theme;
      const $secondaryMenuSlotWrapper = $('.secondary-menu-slot-wrapper');

      $secondaryMenuSlotWrapper.waypoint({
        handler(direction) {
          if (direction === 'down') {
            nt.secondaryMenuSlot.addClass('sticky-active');
          } else {
            nt.secondaryMenuSlot.removeClass('sticky-active');
          }
        },
      });

      nt.window.resize(
        $.throttle(100, () => {
          nt.secondaryMenuSlot.removeClass('sticky-active');
          Waypoint.refreshAll();
        }),
      );
    },

    /**
     * Apply stickiness to category archive page headers.
     */
    applyStickinessToArchivePageHeader: () => {
      const nt = nvb4Theme;
        const $pageHeaderWrapper = $('.page-header-wrapper');
        const $pageHeader = $('.page-header');

      $pageHeaderWrapper.waypoint({
        handler(direction) {
          if (direction === 'down') {
            $pageHeader.addClass('sticky-active');
          } else {
            $pageHeader.removeClass('sticky-active');
          }
        },
      });

      nt.window.resize(
        $.throttle(100, () => {
          $pageHeader.removeClass('sticky-active');
          Waypoint.refreshAll();
        }),
      );
    },

    /**
     * Apply stickiness to sharing bar.
     */
    applyStickinessToSharingLinks: () => {
      const $linksList = $('.nvidia-sharing-links-list');

        if (window.location.pathname === '/') {
          setTimeout(() => {
            if ($linksList.length > 0) {
              // eslint-disable-next-line no-unused-vars
              const sticky = new Waypoint.Sticky({
                element: $linksList[0],
                offset: 148,
              });
            }
          }, 100);
        } else if ($linksList.length > 0) {
          // eslint-disable-next-line no-unused-vars
          const sticky = new Waypoint.Sticky({
            element: $linksList[0],
            offset: 50,
          });
        }
    },

    /**
     * Position the sharing bar.
     */
    applyPositionToSharingLinks: () => {
      $(() => {
        const nav = $('.home .category-posts-area:first article:first');
        if (nav.length > 0) {
          const topPosition = nav.offset().top;
          $('.home .nvidia-sharing-links-wrapper').css({
            top: topPosition,
            display: 'block',
          });
        }
      });
    },

    /**
     * Apply mobile menu toggling.
     */
    enableMobileMenu: () => {
      nt.body.addClass('mobile-menu-active');
      nt.siteNavigation.css('height', `${nt.window.height()}px`);
      nt.siteNavigationInner.css('height', `${nt.window.height()}px`);
    },
    disableMobileMenu: () => {
      nt.body.removeClass('mobile-menu-active');
      nt.siteNavigation.css('height', 'auto');
      nt.siteNavigationInner.css('height', 'auto');
    },
    applyMobileMenuToggling: () => {
      const nt = nvb4Theme;

      nt.mobileMenuToggle.on('click', () => {
        if (nt.body.hasClass('mobile-menu-active')) {
          nt.disableMobileMenu();
        } else {
          nt.enableMobileMenu();
        }
      });

      nt.window.on('resize', () => {
        if (nt.body.hasClass('mobile-menu-active')) {
          if (nt.window.width() <= 678) {
            nt.enableMobileMenu();
          } else {
            nt.disableMobileMenu();
          }
        }
      });
    },

    /**
     * Apply Magnific Popup.
     */
    applyMagnificPopup: () => {
      $('.entry-content').magnificPopup({
        delegate:
          'a[href$=".png"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".gif"]',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError:
            '<span class="nvb4-mfp-error">Image #%curr% could not be loaded.</span>',
          titleSrc(item) {
            const $el = $(item.el);
            const caption = $($el[0]).find('figcaption').clone();
            return caption;
          },
        },
      });
    },

    /**
     * Apply search popovers.
     *
     * @link https://github.com/sandywalker/webui-popover#default-options
     */
    applySearchPopovers: () => {

      $('.js-search-item-link').on('click', (event) => {
        event.preventDefault();
        $('body').toggleClass('search-open');
        $('.search-item .search-field').focus();
      });
    },

    /**
     * Disable links with "no-destination" class.
     */
    disableLinksWithoutDestination: () => {
      $('a.no-destination').on('click', (e) => {
        e.preventDefault();
      });
    },

    /**
     * Provide faux-placeholder interaction in nvb4-email-signup.
     */
    initFauxPlaceholderForEmailSignup: () => {
      $('.nvb4-email-signup .form-item.for-email input').on('blur', () => {
        if ($(this).val().length > 1) {
          $(this).addClass('has-value');
        } else {
          $(this).removeClass('has-value');
        }
      });
    },

    /**
     * For social buttons which connect rather than share via ShareThis service.
     */
    applySocialReplace: () => {
      // eslint-disable-next-line no-restricted-globals
      const stUrl = encodeURIComponent($(location).attr('href'));
      $('.replace-ello').replaceWith(
        '<a href="https://ello.co/nvidia/"><span class="icon icon-ello"></span></a>',
      );
      $('.replace-tumblr').replaceWith(
        `<a href="http://tumblr.com/widgets/share/tool?canonicalUrl=${
          stUrl
          }"><span class="icon icon-tumblr"></span></a>`,
      );
      $('.replace-youtube').replaceWith(
        '<a href="https://www.youtube.com/user/nvidia/"><span class="icon icon-youtube"></span></a>',
      );
      $('.replace-flickr').replaceWith(
        '<a href="https://www.flickr.com/photos/nvidia/"><span class="icon icon-flickr"></span></a>',
      );
      $('.replace-instagram').replaceWith(
        '<a href="https://www.instagram.com/nvidia/"><span class="icon icon-instagram"></span></a>',
      );
      $('.replace-rss').replaceWith(
        '<a href="//blogs.nvidia.com/feed/"><span class="icon icon-rss"></span></a>',
      );
      $('.replace-slideshare').replaceWith(
        '<a href="http://www.slideshare.net/nvidia"><span class="icon icon-slideshare"></span></a>',
      );
    },

    // Load more articles.
    loadMore: () => {
      const loadMoreButton = document.querySelector('#load-more');
      const staticText = loadMoreButton.innerHTML;
      const loadingText = loadMoreButton.getAttribute('data-loading');
      const pageId = loadMoreButton.getAttribute('data-page-id');
      const pageType = loadMoreButton.getAttribute('data-page-type');

      // Change text of button after being localized and passed through data loading attribute.
      loadMoreButton.innerHTML = loadingText;

      // Get post IDs from data attributes.
      const alreadyShown = [];
      $('[data-post-id]:visible').each((index, el) => {
        alreadyShown.push($(el).attr('data-post-id'));
      });

      // Get next posts from rest api
      let postsEndpoint = `${nvb4ThemeVars.siteUrl}/wp-json/nvidia-blog/v1/load-more`;
      postsEndpoint += alreadyShown.length > 0 ? `?exclude=${alreadyShown.join(',')}` : '';
      postsEndpoint += `&pageType=${pageType}`;
      postsEndpoint += `&pageId=${pageId}`;

      fetch(postsEndpoint)
        .then((response) => response.json())
        .then((data) => {
          // Retrieves all the new  articles as raw html
          const newArticles = data.html;

          // Add the new articles to the existing load-more-tiles conatainer
          const loadMoreTiles = document.querySelector('.load-more-tiles');
          loadMoreTiles.innerHTML += newArticles;

          // Hide button if no more pages.
          if (data.hideLoadMore) {
            loadMoreButton.style.display = 'none';
          } else {
            loadMoreButton.innerHTML = staticText;
          }

        })
        .catch((err) => {
          console.log('Check Wordpress REST API', err);
        });

    },

    /**
     * Set click for Load More.
     */
    initMoreStoriesPagination: () => {
      $('#load-more').on('click', (event) => {
        event.preventDefault();
        nvb4Theme.loadMore();
      });
    },

    initHomeSlider: () => {
      const jsHomeMobileSlider = $('.js-home-mobile-slider');
      const $ul = jsHomeMobileSlider.first();
      $('.home-featured-posts-area').children()
        .each((key, elem) => {
          const $li = $('<li></li>');
          $(elem).clone().appendTo($li);
          $li.appendTo($ul);
        });
      jsHomeMobileSlider.bxSlider({
        auto: true,
        pause: 4000,
      });
    },

    getBreakpoint: () => {
      const w = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0,
      );
      if (w <= 768) {
        return 1;
      } if (w <= 1024) {
        return 2;
      }
      return 3;
    },

    getBreakpointImage: (el, breakpoint) => {
      const whichImg = breakpoint === 1 ? 'img-min' : 'img-max';
      return $(el).data(whichImg);
    },

    initImagesForTiles: () => {
      const breakpoint = nvb4Theme.getBreakpoint();
      $('.js-lazy-load-image').each((i, el) => {
        const $el = $(el);
        const imageUrl = nvb4Theme.getBreakpointImage($el, breakpoint);
        $el.attr('style', `background-image:url(${imageUrl})`);
      });
    },

    resizeHeightOnHomepage: () => {
      $('.more-stories-posts-grid article').matchHeight({
        byRow: true,
        property: 'min-height',
        target: null,
        remove: false,
      });
    },

    resizeHeightOnCategory: () => {
      const breakpoint = nvb4Theme.getBreakpoint();
      if (breakpoint === 2) {
        $('.category-latest-news article').matchHeight({
          byRow: true,
          property: 'min-height',
          target: null,
          remove: false,
        });
      }
    },
    closeCookieBar: () => {
      const $cookieWrapper = $('#cookie_notice_div');
      const $cookieDismiss = $('#cookie_notice_div #exit');

      if ($cookieWrapper.length && $cookieDismiss.length) {
        $cookieDismiss.on('click', () => {
          $cookieWrapper.removeClass('is-active');
        });
      }
    },
  };

  $(document).on('ready', () => {
    const nt = nvb4Theme;
    nt.initElCache();
    nt.applyPrimaryMenuIcons();
    nt.applyMobileMenuToggling();
    nt.applyFitvids();
    nt.applySearchPopovers();
    nt.disableLinksWithoutDestination();
    nt.centerSecondaryMenuForMobile();
    nt.initMoreStoriesPagination();
    nt.initHomeSlider();
    nt.applyStickinessToSecondaryMenu();
    nt.resizeHeightOnCategory();
    nt.closeCookieBar();

    // Remove focus classes from menu items on resize.
    nt.window.resize(
      $.throttle(100, () => {
        $('.menu-item.focus').removeClass('focus');
      }),
    );

    nt.applyStickinessToSharingLinks();
    nt.applyPositionToSharingLinks();
    nt.applyMagnificPopup();
    nt.initFauxPlaceholderForEmailSignup();
    nt.initImagesForTiles();

    $(window).on('resize', () => {
      nt.initImagesForTiles();
    });

    $(document).on('yith_infs_added_elem', () => {
      nt.initImagesForTiles();
    });

    if (window.location.pathname === '/') {
      nt.resizeHeightOnHomepage();
    }

    // Get first batch of articles.
    window.firstArticles = $('[data-post-id]');
    if (!$('body').hasClass('site-lang-zh-hans')) {
      $(window).on('scroll', () => {
        $(document).find('video').each(() => {
          if ($(this).isOnScreen()) {
            $(this)[0].play();
          } else {
            $(this)[0].pause();
          }
        });
      });
    }
  });

  // Add isOnScreen function to jQuery
  // eslint-disable-next-line no-param-reassign
  $.fn.isOnScreen = () => {
    const win = $(window);

    const viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft(),
    };

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    const bounds = $(this).offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return !(
      viewport.right < bounds.left
      || viewport.left > bounds.right
      || viewport.bottom < bounds.top
      || viewport.top > bounds.bottom
    );
  };
})(jQuery);
